module.exports = require("@swa-util/string");